<template>
  <div class="intercom-container">
    <transition name="bounce">
      <div v-if="messageCount > 0" id="dot-icon" class="dot-icon">
        <small class="message-count">{{ messageNotification }}</small>
      </div>
    </transition>
    <FriedRoundedButton
      data-external="top-bar-intercom-button"
      class="support-button"
      :active="isOpened"
      @click="handleIntercomClick"
      @keydown.prevent.down.up
    >
      <template #icon>
        <FriedIcon icon="support-headset" />
      </template>
      <span class="hidden-sm-and-down">{{ $t('get-support') }}</span>
    </FriedRoundedButton>
  </div>
</template>

<script lang="ts">
import { getGlobalHandle } from '@getaccept/lib-shared/src/helpers';
import { defineComponent, ref, computed, onMounted } from 'vue';
export default defineComponent({
  setup() {
    const truncateLimit = 99;

    const messageCount = ref(0);
    const isOpened = ref(false);

    const messageNotification = computed(() => {
      if (messageCount.value > truncateLimit) {
        return '...';
      }
      return messageCount.value;
    });

    const handleIntercomClick = () => {
      if (!getGlobalHandle().Intercom) {
        return;
      }

      if (!isOpened.value) {
        getGlobalHandle().Intercom('show');
      } else {
        getGlobalHandle().Intercom('hide');
      }
    };

    onMounted(() => {
      if (!getGlobalHandle().Intercom) {
        return;
      }

      getGlobalHandle().Intercom('onShow', () => {
        isOpened.value = true;
      });
      getGlobalHandle().Intercom('onHide', () => {
        isOpened.value = false;
      });
      getGlobalHandle().Intercom('onUnreadCountChange', unreadCount => {
        messageCount.value = unreadCount;
      });
    });

    return { messageCount, isOpened, messageNotification, handleIntercomClick };
  },
});
</script>

<style lang="scss" scoped>
.intercom-container {
  display: flex;
  align-items: center;

  .dot-icon {
    position: relative;
    right: -2.6rem;
    top: -0.9rem;
    width: 1.25rem;
    height: 1.25rem;
    display: flex;
    z-index: 1;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(--error-dark);

    .message-count {
      position: absolute;
      color: var(--white);
    }
  }

  .support-button {
    :deep(.text) {
      font-size: 0.75rem;
    }
    @media only screen and (max-width: calc(#{$sm} - 1px)) {
      :deep(.text) {
        padding: 0;
      }
    }

    :deep(.icon) {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>
